module.exports = __webpack_public_path__ + "img/5-3.5c5c3109.png";